/**
 * Profile scoping for profile-specific fetches (Batch B).
 *
 * Root cause of B1–B6: profile-scoped data was requested without the active
 * profile's id, so the backend answered for the account owner. Every
 * profile-scoped request derives its subject from one place:
 *
 *   userInfo.profile_id  → a family profile (App's activeProfileUserInfo)
 *   userInfo.user_id     → the account owner
 *   neither              → an unsaved/client chart that belongs to no profile:
 *                          do NOT fetch owner-scoped content for it.
 */

export const subjectOf = (userInfo) => {
  if (userInfo?.profile_id) return { kind: 'profile', key: `profile:${userInfo.profile_id}`, profileId: userInfo.profile_id };
  if (userInfo?.user_id) return { kind: 'self', key: `self:${userInfo.user_id}`, profileId: null };
  return { kind: 'none', key: 'none', profileId: null };
};

/** Query string (`?profile_id=…` or '') for a subject; null when it must not be fetched. */
export const profileQuery = (userInfo) => {
  const s = subjectOf(userInfo);
  if (s.kind === 'none') return null;
  return s.profileId ? `?profile_id=${encodeURIComponent(s.profileId)}` : '';
};

/**
 * `profile_id=…` for the session-list endpoints (B4): a family profile's id,
 * or "self" for the account owner. Those endpoints never serve a reading of
 * unknown subject under either value.
 */
export const sessionProfileParam = (profileId) =>
  `profile_id=${encodeURIComponent(profileId || 'self')}`;
